export const RESET_STATE_DASHBOARD = 'RESET_STATE_DASHBOARD'
export const LOADING_COUNTPERSONS = 'LOADING_COUNTPERSONS'
export const GET_COUNTPERSONS = 'GET_COUNTPERSONS'
export const GET_ERROR_COUNTPERSONS = 'GET_ERROR_COUNTPERSONS'
export const GET_COUNTVEHICULE = 'GET_COUNTVEHICULE'
export const LOADING_COUNTVEHICULE = 'LOADING_COUNTVEHICULE'
export const GET_ERROR_COUNTVEHICULE = 'GET_ERROR_COUNTVEHICULE'
export const SET_VALUESKIN = 'SET_VALUESKIN'
